module.exports = __webpack_public_path__ + "img/announcement.830d2647.png";